import {Component, ElementRef, Inject, PLATFORM_ID, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {FormStatus} from '@iw-shop/forms/components/submit-button/submit-button.component';
import {Store} from '@ngrx/store';
import {AppState} from '@store/state/app.state';
import {Subject, takeUntil} from 'rxjs';
import {MappedCustomer} from '@store/state/user.state';
import {CustomerService} from '@iw-shop/customer/services/customer.service';
import {getSelectedCustomer} from '@store/selectors/user.selector';
import {faCalendar} from "@fortawesome/free-regular-svg-icons";
import {refreshMappedCustomer, setMappedCustomers, setUser, updateMappedCustomer} from "@store/actions/user.action";
import {take} from "rxjs/operators";
import {isPlatformBrowser} from "@angular/common";
import {ApiError} from "@api/api-error";

@Component({
    selector: 'iw-shop-customer-data',
    standalone: false,
    templateUrl: './customer-data.component.html',
    styleUrls: ['./customer-data.component.scss']
})
export class CustomerDataComponent {
    @ViewChild('datePicker') datePicker!: ElementRef;

    protected readonly isBrowser: boolean;

    destroy$: Subject<boolean> = new Subject<boolean>();

    form: FormGroup;
    formStatus?: FormStatus = null;

    apiError?: ApiError;

    userId?: string;
    selectedCustomer?: MappedCustomer;
    dateOfBirthMin: Date;
    dateOfBirthMax: Date;

    constructor(private store: Store<AppState>, private fb: FormBuilder, private customerService: CustomerService, @Inject(PLATFORM_ID) platformId: Object) {
        this.isBrowser = isPlatformBrowser(platformId);
        this.form  = this.fb.group({
            customerNumber: this.fb.control({value: '', disabled: true}),
            priceGroup: this.fb.control({value: '', disabled: true}),
            priceMode: this.fb.control('gross'),
            dateOfBirth: this.fb.control('', [Validators.required]),
            dynamicArticleIds: this.fb.control([]),
        });

        const year = new Date().getFullYear();
        this.dateOfBirthMax = new Date(year - 18, 0, 0);
        this.dateOfBirthMin = new Date(year - 120, 0, 0);
        this.store.select(state => state.user.id)
            .pipe(
                take(1)
            )
            .subscribe(
                id => {
                    this.userId = id;
                }
            )
        this.store.select(getSelectedCustomer)
            .pipe(
                takeUntil(this.destroy$)
            )
            .subscribe(
                c => {
                    if (c) {

                        this.form.get('customerNumber')?.setValue(c.customerNumber);
                        this.form.get('priceGroup')?.setValue(c.priceGroup);
                        if (c.priceMode) {
                            this.form.get('priceMode')?.setValue(c.priceMode);
                        }
                        if (c.dateOfBirth) {
                            this.form.get('dateOfBirth')?.setValue(new Date(c.dateOfBirth));
                        }
                        this.selectedCustomer = c;
                    }
                }
            );
    }

    selectYear(){
        if(this.isBrowser &&
            this.form.get('dateOfBirth')?.value == '' ||
            this.form.get('dateOfBirth')?.value == null){
            setTimeout(() => {
                // 2. Find and click the year button
                const btns = document.querySelectorAll('button.p-datepicker-select-year');
                btns.forEach(btn => {
                    (btn as HTMLButtonElement).click();
                });
            }, 100);
        }
    }

    isFormRequestError(value: string): boolean {
        let form = this.form?.get(value);
        return !!(form?.errors &&
            this.formStatus == 'submitForm');
    }

    submit() {
        this.apiError = undefined;
        this.formStatus = 'submitForm'
        if(!this.form.valid){
            return;
        }
        if (this.selectedCustomer) {
            this.formStatus = 'loading';
            this.customerService.update({
                id: this.selectedCustomer?.id,
                priceMode: this.form.get('priceMode')?.value,
                dateOfBirth: this.form.get('dateOfBirth')?.value ?? '',
                dynamicArticleIds: this.form.get('dynamicArticleIds')?.value ?? []
            })
                .subscribe(
                    {
                        next: (r) => {
                            this.formStatus = 'submitForm';
                            if (r.error) {
                                this.apiError = r.error;
                                window.scroll({
                                    top: 0,
                                    left: 0,
                                    behavior: 'smooth'
                                });
                            } else {
                                this.formStatus = 'success';
                                this.store.dispatch(refreshMappedCustomer({customerId: this.selectedCustomer?.id ?? ''}));
                                setTimeout(() => {
                                    this.formStatus = null;
                                }, 1000);


                            }
                        },
                        complete: () => {
                        },
                        error: () => {
                            this.formStatus = 'submitForm';
                        }
                    }
                )
        }

    }

    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.unsubscribe();
    }

    protected readonly faCalendar = faCalendar;
}
